import script from "./VideoSessionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoSessionView.vue?vue&type=script&lang=ts&setup=true"

import "./VideoSessionView.vue?vue&type=style&index=0&id=3dbbe149&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3dbbe149"]])

export default __exports__